import React from 'react';

import { Button } from '@lightspeed/flame/Button';
import { Flex } from '@lightspeed/flame/Core';
import { IconVerified } from '@lightspeed/flame/Icon/Verified';
import { ModalBody, ModalFooter, ModalHeader } from '@lightspeed/flame/Modal';
import { Spinner } from '@lightspeed/flame/Spinner';
import { Text } from '@lightspeed/flame/Text';

import { ConfirmModal, StatusModal } from './SendToNuorderModal.style';

interface SendToNuorderModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSend: () => void;
  id: number;
}

interface SendToNuorderProcessingModalProps {
  isOpen: boolean;
  onClose: () => void;
}

interface SendToNuorderSuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  id: number;
}

export const SendToNuorderModal: React.FC<SendToNuorderModalProps> = ({
  id,
  isOpen,
  onClose,
  onSend,
}) => {
  return (
    <ConfirmModal isOpen={isOpen} onRequestClose={onClose}>
      <ModalHeader data-test="send-to-nuorder-modal-header">
        Send PO #<var>{id}</var> and submit working order?
      </ModalHeader>
      <ModalBody>
        <Text mb={2}>
          The PO will be sent to NuORDER and a working order will be submitted to the vendor.
        </Text>
        <Text fontWeight={600}>Once sent, changes to the PO must be made through NuORDER.</Text>
      </ModalBody>
      <ModalFooter>
        <Flex justifyContent="end">
          <Button mr={2} onClick={onClose} data-test="send-to-nuorder-modal-review-btn">
            Review
          </Button>
          <Button
            fill
            variant="secondary"
            onClick={onSend}
            data-test="send-to-nuorder-modal-send-btn"
          >
            Send to NuORDER
          </Button>
        </Flex>
      </ModalFooter>
    </ConfirmModal>
  );
};

export const SendToNuorderProcessingModal: React.FC<SendToNuorderProcessingModalProps> = ({
  isOpen,
  onClose,
}) => {
  return (
    <StatusModal isOpen={isOpen} onRequestClose={onClose} shouldCloseOnOverlayClick={false}>
      <ModalHeader style={{ textAlign: 'center' }} showCloseButton={false}>
        Sending to NuORDER
      </ModalHeader>
      <ModalBody style={{ textAlign: 'center' }} data-test="send-to-nuorder-modal-processing">
        <Spinner size="100px" baseColor="blue-400" />
        <Text pt={2} fontWeight={600}>
          Order is being sent. This could take a few minutes.
        </Text>
      </ModalBody>
    </StatusModal>
  );
};

export const SendToNuorderSuccessModal: React.FC<SendToNuorderSuccessModalProps> = ({
  isOpen,
  onClose,
  id,
}) => {
  return (
    <StatusModal isOpen={isOpen} onRequestClose={onClose}>
      <ModalHeader style={{ textAlign: 'center' }}>Success!</ModalHeader>
      <ModalBody style={{ textAlign: 'center' }} data-test="send-to-nuorder-modal-success">
        <IconVerified size="100px" baseColor="primary" />
        <Text pt={2} fontWeight={600}>
          PO #<var>{id}</var> successfully sent to NuORDER
        </Text>
      </ModalBody>
    </StatusModal>
  );
};
